import script from "./IconModal.vue?vue&type=script&setup=true&lang=js"
export * from "./IconModal.vue?vue&type=script&setup=true&lang=js"

import "./IconModal.vue?vue&type=style&index=0&id=44982f02&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/inticons/inticons/docs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44982f02"]])

export default __exports__